import { buildCompanyPatchFromFormDataMatchingFields, buildCompanyPatchFromMatchingFields, } from './company-patch';
const contactPatchFields = [
    'title',
    'first_name',
    'last_name',
    'email',
    'phone',
    'ext',
    'preferred_language',
    'gender',
];
export const clientContactPatchFields = contactPatchFields;
export const adminContactPatchFields = [
    ...contactPatchFields,
    'comments',
    'auth_id',
    'company_id',
];
export const buildContactPatchFromMatchingFields = (values, current, fields = contactPatchFields) => buildCompanyPatchFromMatchingFields(values, current, fields);
export const buildContactPatchFromFormDataMatchingFields = (data, current, fields = contactPatchFields) => buildCompanyPatchFromFormDataMatchingFields(data, current, fields);
